/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис управления системными настройками устройства
 */

/**
 * Сервис управления системными настройками устройства
 */
export class SystemServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод удаленной перезагрузки
   */
  PostSystemReboot = (req?: PostSystemRebootRequestDto, init?: RequestInit): Promise<PostSystemRebootResponseDto> => {
    return fm.request<PostSystemRebootRequestDto, PostSystemRebootResponseDto>(`${this.host}/device/api/v1/system/reboot`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения общей информации об устройстве
   */
  GetSystemInfo = (req?: GetSystemInfoRequestDto, init?: RequestInit): Promise<GetSystemInfoResponseDto> => {
    return fm.request<GetSystemInfoRequestDto, GetSystemInfoResponseDto>(`${this.host}/device/api/v1/system/info${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Общая информация об устройстве
 */
export type DeviceInfoRequestDto = {
  /**
   * Версия программного обеспечения
   */
  firmwareVersion?: string
  /**
   * Версия аппаратного обеспечения
   */
  hardwareVersion?: string
  /**
   * Модель
   */
  model?: string
  /**
   * MAC-адрес.
   * Диапазон: 17..17.
   * Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/
   */
  macAddress?: string
  /**
   * IP адрес.
   * Диапазон: 7..15.
   * Паттерн: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
   */
  ip?: string
  /**
   * Серийный номер
   */
  serialNumber?: string
  /**
   * Время работы в секундах.
   * Диапазон: 0..2147483647
   */
  uptime?: number
  /**
   * Версия программного обеспечения микроконтроллера
   */
  mcFirmwareVersion?: string
}
/**
 * Общая информация об устройстве
 */
export type DeviceInfoResponseDto = {
  /**
   * Версия программного обеспечения
   */
  firmwareVersion: string
  /**
   * Версия аппаратного обеспечения
   */
  hardwareVersion: string
  /**
   * Модель
   */
  model: string
  /**
   * MAC-адрес.
   * Диапазон: 17..17.
   * Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/
   */
  macAddress: string
  /**
   * IP адрес.
   * Диапазон: 7..15.
   * Паттерн: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
   */
  ip: string
  /**
   * Серийный номер
   */
  serialNumber: string
  /**
   * Время работы в секундах.
   * Диапазон: 0..2147483647
   */
  uptime: number
  /**
   * Версия программного обеспечения микроконтроллера
   */
  mcFirmwareVersion: string
}
/**
 * Запрос получения общей информации об устройстве
 */
export type GetSystemInfoRequestDto = {
}
/**
 * Ответ на запрос получения общей информации об устройстве
 */
export type GetSystemInfoResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Общая информация об устройстве
   */
  readonly data: DeviceInfoResponseDto
}>
/**
 * Запрос удаленной перезагрузки
 */
export type PostSystemRebootRequestDto = {
}
/**
 * Ответ на запрос удаленной перезагрузки
 */
export type PostSystemRebootResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Общая информация об устройстве
   */
  "DeviceInfo": {
    "kind": "class",
    "text": "Общая информация об устройстве",
    "fields": {
      /**
       * Версия программного обеспечения
       */
      "firmwareVersion": {
        "type": "string",
        "text": "Версия программного обеспечения",
      },
      /**
       * Версия аппаратного обеспечения
       */
      "hardwareVersion": {
        "type": "string",
        "text": "Версия аппаратного обеспечения",
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
      },
      /**
       * MAC-адрес.
       * Диапазон: 17..17.
       * Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/
       */
      "macAddress": {
        "type": "string",
        "text": "MAC-адрес.\nДиапазон: 17..17.\nПаттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/",
      },
      /**
       * IP адрес.
       * Диапазон: 7..15.
       * Паттерн: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
       */
      "ip": {
        "type": "string",
        "text": "IP адрес.\nДиапазон: 7..15.\nПаттерн: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/",
      },
      /**
       * Серийный номер
       */
      "serialNumber": {
        "type": "string",
        "text": "Серийный номер",
      },
      /**
       * Время работы в секундах.
       * Диапазон: 0..2147483647
       */
      "uptime": {
        "type": "int32",
        "text": "Время работы в секундах.\nДиапазон: 0..2147483647",
      },
      /**
       * Версия программного обеспечения микроконтроллера
       */
      "mcFirmwareVersion": {
        "type": "string",
        "text": "Версия программного обеспечения микроконтроллера",
      },
    },
  },
  /**
   * Запрос получения общей информации об устройстве
   */
  "GetSystemInfoRequest": {
    "kind": "class",
    "text": "Запрос получения общей информации об устройстве",
  },
  /**
   * Ответ на запрос получения общей информации об устройстве
   */
  "GetSystemInfoResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения общей информации об устройстве",
    "fields": {
      /**
       * Общая информация об устройстве
       */
      "data": {
        "type": "DeviceInfo",
        "text": "Общая информация об устройстве",
      },
    },
  },
  /**
   * Запрос удаленной перезагрузки
   */
  "PostSystemRebootRequest": {
    "kind": "class",
    "text": "Запрос удаленной перезагрузки",
  },
  /**
   * Ответ на запрос удаленной перезагрузки
   */
  "PostSystemRebootResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаленной перезагрузки",
  },
}